import { render, staticRenderFns } from "./StaffSelector.vue?vue&type=template&id=2aea0896&scoped=true"
import script from "./StaffSelector.vue?vue&type=script&lang=js"
export * from "./StaffSelector.vue?vue&type=script&lang=js"
import style0 from "./StaffSelector.vue?vue&type=style&index=0&id=2aea0896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea0896",
  null
  
)

export default component.exports